import { render, staticRenderFns } from "./DefaultListWithSubHeader.vue?vue&type=template&id=53de503f&scoped=true"
import script from "./DefaultListWithSubHeader.vue?vue&type=script&lang=js"
export * from "./DefaultListWithSubHeader.vue?vue&type=script&lang=js"
import style0 from "./DefaultListWithSubHeader.vue?vue&type=style&index=0&id=53de503f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53de503f",
  null
  
)

export default component.exports